import { Paper, useTheme } from '@mui/material';
import * as React from 'react';

interface TopBorderPaperProps {
  children?: React.ReactNode;
  sx?: any;
}

export const TopBorderPaper: React.FC<TopBorderPaperProps> = (props) => {
  const { children, sx } = props;
  const theme = useTheme();

  return (
    <Paper
      elevation={12}
      sx={{
        ...sx,
        borderTopWidth: 4,
        borderTopColor: theme.palette.primary.light,
        borderTopStyle: 'solid',
      }}
    >
      {children}
    </Paper>
  );
};
